<template>
  <!-- MODAL Table Fire Alarm -->
  <b-modal
    id="modalFireAlarm"
    title="Fire Alarm"
    size="xl"
    ok-only
  >
    <b-row>
      <b-col cols="12">
        <b-card>
          <!-- table -->
          <b-table
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(graph)="data">
              <b-link
                v-b-modal="'modalGraphFire'"
                @click="$refs.childref.graphModalFire(data.item.devid)"
              ><feather-icon
                class="text-primary"
                icon="TrendingUpIcon"
                size="20"
              />{{ data.value }}
              </b-link>
            </template>
            <template
              #cell(Alarm)="data"
            >
              <b-badge
                v-if="data.item.Alarm >= 1"
                variant="danger"
              >
                Alarm
              </b-badge>
              <b-badge
                v-if="data.item.Normal >= 1"
                variant="success"
              >
                Normal
              </b-badge>
            </template>
            <template #cell(connect)="data">
              <b-badge :variant="connect[1][data.value]">
                {{ connect[0][data.value] }}
              </b-badge>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <GraphFireAlarm
      ref="childref"
      @fetch="getFireAlarm()"
    />
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BCard, BTable, BBadge, BLink,
} from 'bootstrap-vue'
import GraphFireAlarm from '@/views/StatisModal/Graph/GraphFireAlarm.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BBadge,
    BLink,
    GraphFireAlarm,
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'graph', label: 'Graph', class: 'text-center' },
        {
          key: 'devbuilding', label: 'Building', sortable: true, class: 'text-left',
        },
        {
          key: 'devid', label: 'ID', sortable: true, class: 'text-left',
        },
        {
          key: 'Alarm', label: 'Status', sortable: true, class: 'text-center',
        },
        {
          key: 'lastupdate', label: 'LastUpdate', sortable: true, class: 'text-center',
        },
        {
          key: 'connect', label: 'Connected', sortable: true, class: 'text-center',
        },
      ],
      perPage: '',
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      connect: [{
        Offline: 'non-connect', Online: 'connect',
      },
      {
        Offline: 'light-danger', Online: 'light-success',
      }],
      status: [{
        Offline: 'non-connect', Online: 'connect',
      },
      {
        Offline: 'light-danger', Online: 'light-success',
      }],
    }
  },
  mounted() {
    this.getFireAlarm()
  },
  methods: {
    getFireAlarm() {
      axios
        .get('/get-tableFire')
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.perPage = response.data.length
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
  },
}
</script>

<style>

</style>
